require('angular').module('wowApp.common')
    .service('SavedListsService', ['Restangular', '$q', 'BootstrapService', 'AnalyticsService', require('./saved-lists.service')]);



// WEBPACK FOOTER //
// ./src/common/savedlists/index.js